import { Spacing8 } from 'autogen/design-tokens/tokens';
import Flex from 'components/Layout/components/Flex';
import type { BasketMessagesViewModel } from 'autogen/swagger/all';
import BasketMessageRenderer from './BasketMessageRenderer';

export default function BasketMessages({ model }: { model?: BasketMessagesViewModel }) {
    if (!model) return null;

    return (
        <Flex.Column gap={Spacing8}>
            <BasketMessageRenderer model={model} />
        </Flex.Column>
    );
}
